import { Component, OnInit } from '@angular/core';

import { environment } from 'src/environments/environment';
@Component({
  templateUrl: './footer.component.html',
  selector: 'footer-component'
})
export class FooterComponent implements OnInit {
  isBanking: boolean = false
  environment: any;
  constructor() { 
    this.environment = environment
    this.isBanking = environment.env === "banking"
  }

  ngOnInit() {

  }
}